module.exports = "<p>\n  app-user-edit works!\n</p>\n"